import { Trans as I18nextTrans } from 'react-i18next';
import type { ComponentProps } from 'react';

/**
 * Trans parses interpolated values as component markup before React can escape them.
 * Escape before that parse, then decode entities in text nodes to preserve the original text.
 */
export const Trans: typeof I18nextTrans = ({ tOptions, ...props }: ComponentProps<typeof I18nextTrans>) => (
  <I18nextTrans
    {...props}
    tOptions={{
      ...tOptions,
      interpolation: { ...tOptions?.interpolation, escapeValue: true },
    }}
    shouldUnescape
  />
);
